"use client";

import { useContext } from "react";
import { RootStoreContext } from "../context";
import type { TenantStore } from "../../mobx/lib/models/tenant-store";

export function useTenant(): TenantStore {
  const root = useContext(RootStoreContext);
  if (!root)
    throw new Error("useTenant must be used within a RootStoreProvider");
  return root.tenant;
}
